import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Helper } from 'src/app/helper/defult';
import { AuthService } from 'src/app/services/auth.service';
import { HttpIOService } from 'src/app/services/http-io.service';
import { DeleteConfirmationComponent } from '../delete-confirmation/delete-confirmation.component';
import { UUID } from 'angular2-uuid';
import { DynamicSnacbarComponent } from 'src/app/container/elements/dynamic-snacbar/dynamic-snacbar.component';

@Component({
  selector: 'app-js-license-or-certificate',
  templateUrl: './js-license-or-certificate.component.html',
  styleUrls: ['./js-license-or-certificate.component.scss'],
})
export class JsLicenseOrCertificateComponent implements OnInit {
  declrationCheckBox: any;
  checked: boolean = false;
  disabled = false;
  userDeatils: any;
  companyData: any;
  certificateORlisenceForm: UntypedFormGroup;
  show: boolean = false;
  WholeRecord: any;
  index: any;
  uuidValue: string;
  toDay: any = new Date();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private titleService: Title,
    private router: Router,
    private io: HttpIOService,
    private helper: Helper,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<JsLicenseOrCertificateComponent>,
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    public datepipe: DatePipe
  ) {
    let localUser = localStorage.getItem('workNigeriaUser');
    let sessionUser = sessionStorage.getItem('workNigeriaUser');
    if (localUser) {
      this.userDeatils = JSON.parse(
        this.helper.fromBinary(atob(localStorage.getItem('workNigeriaUser')))
      );
      this.companyData = this.auth.getCurrentCompanyData();
    }
    if (sessionUser) {
      this.userDeatils = JSON.parse(
        this.helper.fromBinary(atob(sessionStorage.getItem('workNigeriaUser')))
      );
      this.companyData = this.auth.getCurrentCompanyDataInSessoin();
    }
  }

  ngOnInit(): void {
    console.log(this.data);
    this.validationForm();
    if (this.data['data'] != 'NEW' && this.data['data'] != 'confirm') {
      this.patchValue();
      this.show = true;
      this.WholeRecord = this.data['wholeData'];
      this.index = this.WholeRecord.findIndex(
        (id) => id.id == this.data['data'].id
      );
      // console.log(this.index);
    }
    if (this.data['data'].stillWorking == true) {
      this.checkDeclaration(true);
    }
    if (this.data['data'] == 'confirm') {
      this.uuidValue = UUID.UUID();
      this.WholeRecord = this.data['wholeData'];
    }
  }
  // Validation Controls //
  get f() {
    return this.certificateORlisenceForm.controls;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  validationForm() {
    this.certificateORlisenceForm = this.fb.group({
      Name: ['', Validators.required],
      IssuingOrganization: ['', Validators.required],
      issueDate: [''],
      endDate: [''],
      CredentialID: [''],
      CredentialURL: [''],
    });
  }

  checkDeclaration(event) {
    // console.log(event)
    this.declrationCheckBox = event;
    if (this.declrationCheckBox == true) {
      this.certificateORlisenceForm.controls['endDate'].disable();
      this.certificateORlisenceForm.patchValue({ endDate: '' });
    } else {
      this.certificateORlisenceForm.controls['endDate'].enable();
    }
  }

  patchValue() {
    this.checked = this.data['data'].willLicenseExpire;
    let patchData = {
      Name: this.data['data'].name,
      IssuingOrganization: this.data['data'].issuingOrganization,
      issueDate: this.data['data'].issueDate,
      endDate: this.data['data'].endDate,
      CredentialID: this.data['data'].credentialId,
      CredentialURL: this.data['data'].credentialUrl,
    };
    this.certificateORlisenceForm.patchValue(patchData);
  }
  transformTreeDateTime(value = '', format = 'yyyy-MM-dd') {
    var datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, format);
    return value;
  }
  saveCertificate() {
    if (this.certificateORlisenceForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.certificateORlisenceForm);
      return false;
    }
    if (this.data['data'] == 'confirm') {
      this.WholeRecord.push({
        id: this.uuidValue,
        createdAt: this.toDay.toISOString(),
        name: this.certificateORlisenceForm.get('Name').value,
        issuingOrganization: this.certificateORlisenceForm.get(
          'IssuingOrganization'
        ).value,
        issueDate: this.transformTreeDateTime(
          this.certificateORlisenceForm.get('issueDate').value
        ),
        endDate: this.transformTreeDateTime(
          this.certificateORlisenceForm.get('endDate').value
        ),
        credentialId: this.certificateORlisenceForm.get('CredentialID').value,
        credentialUrl: this.certificateORlisenceForm.get('CredentialURL').value,
        willLicenseExpire:
          this.declrationCheckBox == undefined ? '' : this.declrationCheckBox,
      });
      // console.log(this.WholeRecord)
      this.dialogRef.close(this.WholeRecord);
    } else {
      let jsonData = {
        path: 'add-license',
        id: this.userDeatils.id,
        name: this.certificateORlisenceForm.get('Name').value,
        issuingOrganization: this.certificateORlisenceForm.get(
          'IssuingOrganization'
        ).value,
        issueDate: this.transformTreeDateTime(
          this.certificateORlisenceForm.get('issueDate').value
        ),
        endDate: this.transformTreeDateTime(
          this.certificateORlisenceForm.get('endDate').value
        ),
        credentialId: this.certificateORlisenceForm.get('CredentialID').value,
        credentialUrl: this.certificateORlisenceForm.get('CredentialURL').value,
        willLicenseExpire:
          this.declrationCheckBox == undefined ? '' : this.declrationCheckBox,
      };
      // console.log(jsonData)
      this.io._JSaddLicense(jsonData).subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          // console.log(res);
          this.snackBar
            .openFromComponent(DynamicSnacbarComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top', // 'top' | 'bottom'
              horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
          this.dialogRef.close('save');
        }
      });
    }
  }

  updateLicense() {
    if (this.certificateORlisenceForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.certificateORlisenceForm);
      return false;
    }
    if (this.data['confirm'] == 'confirmLicense') {
      ((this.WholeRecord[this.index].name =
        this.certificateORlisenceForm.get('Name').value),
        (this.WholeRecord[this.index].issuingOrganization =
          this.certificateORlisenceForm.get('IssuingOrganization').value),
        (this.WholeRecord[this.index].issueDate = this.transformTreeDateTime(
          this.certificateORlisenceForm.get('issueDate').value
        )),
        (this.WholeRecord[this.index].endDate = this.transformTreeDateTime(
          this.certificateORlisenceForm.get('endDate').value
        )),
        (this.WholeRecord[this.index].credentialId =
          this.certificateORlisenceForm.get('CredentialID').value),
        (this.WholeRecord[this.index].credentialUrl =
          this.certificateORlisenceForm.get('CredentialURL').value),
        (this.WholeRecord[this.index].willLicenseExpire =
          this.declrationCheckBox == undefined ? '' : this.declrationCheckBox));
      this.dialogRef.close(this.WholeRecord);
    } else {
      ((this.WholeRecord[this.index].name =
        this.certificateORlisenceForm.get('Name').value),
        (this.WholeRecord[this.index].issuingOrganization =
          this.certificateORlisenceForm.get('IssuingOrganization').value),
        (this.WholeRecord[this.index].issueDate = this.transformTreeDateTime(
          this.certificateORlisenceForm.get('issueDate').value
        )),
        (this.WholeRecord[this.index].endDate = this.transformTreeDateTime(
          this.certificateORlisenceForm.get('endDate').value
        )),
        (this.WholeRecord[this.index].credentialId =
          this.certificateORlisenceForm.get('CredentialID').value),
        (this.WholeRecord[this.index].credentialUrl =
          this.certificateORlisenceForm.get('CredentialURL').value),
        (this.WholeRecord[this.index].willLicenseExpire =
          this.declrationCheckBox == undefined ? '' : this.declrationCheckBox));

      let jsonData = {
        path: 'edit-license',
        id: this.userDeatils.id,
        license: this.WholeRecord,
      };
      // console.log(jsonData)
      this.io._JSeditLicense(jsonData).subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          // console.log(res);
          this.snackBar
            .openFromComponent(DynamicSnacbarComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top', // 'top' | 'bottom'
              horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
          this.dialogRef.close('save');
        }
      });
    }
  }

  removeLicense() {
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      //height: '400px',
      width: '400px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'save') {
        if (this.data['confirm'] == 'confirmLicense') {
          this.WholeRecord.splice(this.index, 1);
          this.dialogRef.close(this.WholeRecord);
        } else {
          this.WholeRecord.splice(this.index, 1);
          let jsonData = {
            path: 'edit-license',
            id: this.userDeatils.id,
            license: this.WholeRecord,
          };
          // console.log(jsonData)
          this.io._JSeditLicense(jsonData).subscribe((res: any) => {
            if (res.serverResponse.code == 200) {
              // console.log(res);
              this.snackBar
                .openFromComponent(DynamicSnacbarComponent, {
                  data: res.serverResponse.message,
                  verticalPosition: 'top', // 'top' | 'bottom'
                  horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
                })
                .afterOpened()
                .subscribe(this.helper.setOnTop);
              this.dialogRef.close('save');
            }
          });
        }
      }
    });
  }
}
